import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { Button, Dialog, Classes, Intent
} from "@blueprintjs/core";
import SignatureCanvas from 'react-signature-pad';
import Toast from 'helpers/toaster';

@inject("quoteStore")
@observer
class QuoteAcceptModal extends Component {

  handleCloseQuoteAcceptDialog() {
    this.props.onClose();
  }

  saveSignature() {
    const {
      quoteStore: {
        quote: { object }
      }
    } = this.props;
    let quote_accept = {
      customer_signature: this.sigCanvas.toDataURL('image/png'),
      quote_id: object.id,
      accepted: true
    }

    if(this.sigCanvas.isEmpty()) {
      Toast.show({ message: "Please sign before accept agreement!", intent: Intent.DANGER })
      return;
    }

    this.props.quoteStore.quoteAccept(quote_accept)
      .then(() => {
        this.props.onSuccess()
      })
    
  }

  render() {
    const {
      quoteStore: {
        showAcceptQuoteLoader,
        quote: { object }
      }
    } = this.props;
    return(
      <Dialog
        title="Approve and accept agreement"
        isOpen={this.props.isOpen}
        isCloseButtonShown={true}
        onClose={this.handleCloseQuoteAcceptDialog.bind(this)}
        style={{minWidth: 500}}
        canOutsideClickClose={false}
      >
        <div className={Classes.DIALOG_BODY}>
          <div className="accept-agreement mb-3">
            <label><strong>Estimate agreement</strong></label>
            <div style={{ backgroundColor: '#fff', border: '1px solid #CED4DA', borderRadius: 5, height: 100, overflow: "auto", padding: 15, fontSize: 12 }}>
              <div dangerouslySetInnerHTML={{ __html: object.attributes.agreement_copy }}></div>
            </div>
          </div>
          <div className="signature-canvas mb-3" style={{ backgroundColor: '#fff', border: '2px solid #CED4DA', borderRadius: 5, width: "100%" }}>
            <SignatureCanvas 
              penColor='#1800ff' 
              clearButton="true"
              ref={(ref) => { this.sigCanvas = ref }}
              canvasProps={{ width: '100%', height: 200, className: 'sigCanvas', backgroundColor: 'white' }} />
          </div>
          <div className="text-right">
            <Button text="Accept Agreement" intent="primary" onClick={this.saveSignature.bind(this)} loading={showAcceptQuoteLoader} />
          </div>
        </div>
      </Dialog>
    )
  }

}

export default QuoteAcceptModal;